var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-header-card',{staticClass:"animated fadeIn mt-3",attrs:{"icon":_vm.instrument.icon(),"header":`Instrument ${_vm.instrument.name} details`,"rows":_vm.rows}})
}
var staticRenderFns = []

export { render, staticRenderFns }